export enum LotPrimaryIdentifier {
  LotBlock = "Lot Block",
  Address = "Address"
}

export enum AdminConfigKey {
  CcmReportDistributionList = "CcmReportDistributionList",
  LotPrimaryIdentifier = "LotPrimaryIdentifier"
}

export type TypedAdminConfigKey<T extends AdminConfigKey> =
  T extends AdminConfigKey.CcmReportDistributionList ? string | null :
    T extends AdminConfigKey.LotPrimaryIdentifier ? LotPrimaryIdentifier | null :
  string | null;

export interface ClientAdminConfigValueDto<T extends AdminConfigKey> {
  value: TypedAdminConfigKey<T>;
  defaultValue: TypedAdminConfigKey<T>;
}

export interface DivisionClientAdminConfigDto {
  id: number;
  name: string;
  externalDivisionId: number;
  configs: Record<string, ClientAdminConfigValueDto<AdminConfigKey>>;
}